import React, { useState } from 'react';
import { formatIstDate } from '../../../../utils/helpers/istDate';

const fmtDate = (value) => {
    if (!value) return '—';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '—';
    return formatIstDate(d);
};

const StatusPill = ({ status }) => {
    const normalized = String(status || '').toUpperCase();
    const isActive = normalized === 'ACTIVE' || status === true || status === 1;
    const isReview = normalized === 'UNDER_REVIEW' || normalized === 'PENDING';
    let cls = 'tw-bg-gray-50 tw-text-gray-500 tw-border-gray-100';
    let label = normalized.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) || 'Inactive';
    let dot = 'tw-bg-gray-400';
    if (isActive) {
        cls = 'tw-bg-emerald-50 tw-text-emerald-600 tw-border-emerald-100';
        label = 'Active';
        dot = 'tw-bg-emerald-500';
    } else if (isReview) {
        cls = 'tw-bg-amber-50 tw-text-amber-600 tw-border-amber-100';
        dot = 'tw-bg-amber-500';
    }
    return (
        <span className={`tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[10px] tw-font-medium tw-border ${cls}`}>
            <span className={`tw-w-1.5 tw-h-1.5 tw-rounded-full ${dot}`} />
            {label}
        </span>
    );
};

const LatestPerformanceOne = ({ recentSocieties = [], recentUsers = [] }) => {
    const [tab, setTab] = useState('societies');
    const societies = Array.isArray(recentSocieties) ? recentSocieties : [];
    const users = Array.isArray(recentUsers) ? recentUsers : [];

    return (
        <div className="col-xxl-6">
            <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm tw-overflow-hidden h-100 tw-flex tw-flex-col">
                {/* Tabs */}
                <div className="tw-px-4 tw-py-3 tw-border-b tw-border-gray-100 tw-flex tw-items-center tw-gap-1">
                    <button
                        type="button"
                        onClick={() => setTab('societies')}
                        className={`tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-rounded-md tw-border-0 tw-transition-colors ${
                            tab === 'societies' ? 'tw-bg-rose-50 tw-text-rose-600' : 'tw-bg-transparent tw-text-gray-500 hover:tw-text-rose-600'
                        }`}
                    >
                        Recent Society
                    </button>
                    <button
                        type="button"
                        onClick={() => setTab('users')}
                        className={`tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-rounded-md tw-border-0 tw-transition-colors ${
                            tab === 'users' ? 'tw-bg-rose-50 tw-text-rose-600' : 'tw-bg-transparent tw-text-gray-500 hover:tw-text-rose-600'
                        }`}
                    >
                        Recent Users
                    </button>
                </div>

                {/* Body */}
                <div className="tw-overflow-x-auto tw-flex-1">
                    {tab === 'societies' ? (
                        <table className="tw-w-full tw-text-xs">
                            <thead>
                                <tr className="tw-bg-gradient-to-r tw-from-slate-50 tw-to-gray-50">
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">Society</th>
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">ID</th>
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">Date</th>
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">City</th>
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">Status</th>
                                </tr>
                            </thead>
                            <tbody className="tw-divide-y tw-divide-gray-50">
                                {societies.length === 0 ? (
                                    <tr><td colSpan={5} className="tw-text-center tw-text-gray-400 tw-py-6">No recent societies</td></tr>
                                ) : societies.map((s) => (
                                    <tr key={s.society_id} className="hover:tw-bg-slate-50/50 tw-transition-colors">
                                        <td className="tw-px-4 tw-py-2.5 tw-font-medium tw-text-gray-800">{s.name || '—'}</td>
                                        <td className="tw-px-4 tw-py-2.5 tw-text-rose-600 tw-font-mono">#{s.society_code || s.society_id}</td>
                                        <td className="tw-px-4 tw-py-2.5 tw-text-gray-500 tw-whitespace-nowrap">{fmtDate(s.date)}</td>
                                        <td className="tw-px-4 tw-py-2.5 tw-text-gray-600">{s.city || '—'}</td>
                                        <td className="tw-px-4 tw-py-2.5"><StatusPill status={s.status} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <table className="tw-w-full tw-text-xs">
                            <thead>
                                <tr className="tw-bg-gradient-to-r tw-from-slate-50 tw-to-gray-50">
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">User</th>
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">Type</th>
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">Society</th>
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">Last Login</th>
                                    <th className="tw-text-left tw-px-4 tw-py-2.5 tw-font-semibold tw-text-gray-600 tw-uppercase tw-tracking-wider tw-text-[10px]">Status</th>
                                </tr>
                            </thead>
                            <tbody className="tw-divide-y tw-divide-gray-50">
                                {users.length === 0 ? (
                                    <tr><td colSpan={5} className="tw-text-center tw-text-gray-400 tw-py-6">No recent users</td></tr>
                                ) : users.map((u) => (
                                    <tr key={u.user_id} className="hover:tw-bg-slate-50/50 tw-transition-colors">
                                        <td className="tw-px-4 tw-py-2.5">
                                            <div className="tw-font-medium tw-text-gray-800">{u.name || '—'}</div>
                                            <div className="tw-text-[10px] tw-text-gray-400 tw-font-mono">#{u.user_id}</div>
                                        </td>
                                        <td className="tw-px-4 tw-py-2.5 tw-text-gray-600">{u.user_type || '—'}</td>
                                        <td className="tw-px-4 tw-py-2.5 tw-text-gray-600">{u.society || '—'}</td>
                                        <td className="tw-px-4 tw-py-2.5 tw-text-gray-500 tw-whitespace-nowrap">{fmtDate(u.last_login_at)}</td>
                                        <td className="tw-px-4 tw-py-2.5"><StatusPill status={u.is_active} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LatestPerformanceOne;
